import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  Box,
} from '@mui/material';
import { Comment as CommentIcon, Tune as TuneIcon } from '@mui/icons-material';
import { DebouncedInput } from './DebouncedInput';

function displayVal(v) {
  return v === null || v === undefined ? '' : v;
}

export function GeneralFeedback({ group, onUpdate }) {
  const handleAdjustmentChange = (studentId, value) => {
    const newAdjustments = { ...(group.generalAdjustments || {}) };
    if (value === '' || value === 0) {
      delete newAdjustments[studentId];
    } else {
      newAdjustments[studentId] = parseFloat(value);
    }
    onUpdate({ ...group, generalAdjustments: newAdjustments });
  };

  return (
    <Paper sx={{ p: 4, mb: 4, bgcolor: '#f9fbe7', border: '1px solid #e0e0e0' }}>
      <Typography variant="h6" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center' }}>
        <CommentIcon sx={{ mr: 1 }} /> General Feedback & Adjustments
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={7}>
          <Typography variant="subtitle2" gutterBottom>
            General Comments
          </Typography>
          <DebouncedInput
            multiline
            rows={6}
            fullWidth
            variant="outlined"
            placeholder="Overall feedback for the group..."
            value={displayVal(group.generalComment)}
            onCommit={(v) => onUpdate({ ...group, generalComment: v })}
            sx={{ bgcolor: 'white' }}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <Typography variant="subtitle2" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
            <TuneIcon sx={{ mr: 1, fontSize: 18 }} />
            Student Adjustments (Rate 0-1)
          </Typography>
          <Typography variant="caption" display="block" color="text.secondary" paragraph>
            Enter a multiplier to adjust a student&apos;s final score (e.g. 1 = 100%, 0.5 = 50%, 0 = 0%).
          </Typography>
          <Box sx={{ bgcolor: 'white', p: 2, borderRadius: 1, border: '1px solid #e0e0e0' }}>
            {group.students && group.students.length > 0 ? (
              group.students.map((s) => (
                <Box
                  key={s.studentId}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                    '&:last-child': { mb: 0 },
                  }}
                >
                  <Box sx={{ overflow: 'hidden', mr: 2 }}>
                    <Typography variant="body2" fontWeight="bold" noWrap>
                      {s.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" noWrap>
                      {s.studentId}
                    </Typography>
                  </Box>
                  <DebouncedInput
                    type="number"
                    size="small"
                    placeholder="1.0"
                    label="Rate"
                    variant="outlined"
                    sx={{ width: '80px' }}
                    onWheel={(e) => e.target.blur()}
                    value={displayVal(group.generalAdjustments?.[s.studentId])}
                    onCommit={(v) => handleAdjustmentChange(s.studentId, v)}
                    InputProps={{
                      inputProps: { step: 0.1, min: 0, max: 1 },
                      sx: {
                        color:
                          group.generalAdjustments?.[s.studentId] !== undefined &&
                          group.generalAdjustments?.[s.studentId] < 1
                            ? 'error.main'
                            : 'text.primary',
                        fontWeight: 'bold',
                      },
                    }}
                  />
                </Box>
              ))
            ) : (
              <Typography variant="body2" fontStyle="italic" color="text.secondary" align="center">
                No students added.
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
